var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLaptop)?_c('LaptopDocuments',{attrs:{"isLaptop":_vm.isLaptop}}):_c('MobileDocuments',{attrs:{"isLaptop":_vm.isLaptop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }